<template>
    <div
        class="load-more center-element"
        v-infinite-scroll="infiniteLoadingEvent"
        infinite-scroll-disabled="disableInfiniteScroll"
        infinite-scroll-distance="infiniteScrollDistance"
        @click="clickLoadingEvent"
    >
        <div v-if="text" class="text">{{ text }}</div>
        <i class="fas fa-angle-down"></i>
    </div>
</template>

<script>
export default {
    name: 'LoadMore',
    props: {
        text: {
            type: String,
            default: ''
        },
        loadType: {
            type: String,
            default: 'infinite'
        },
        disableInfiniteScroll: {
            type: Boolean,
            default: false
        },
        infiniteScrollDistance: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loadTypes: ['click', 'infinite']
        };
    },
    methods: {
        clickLoadingEvent: function() {
            if (this.loadType === this.loadTypes[0]) {
                this.$emit('load-event');
            }
        },
        infiniteLoadingEvent: function() {
            if (this.loadType === this.loadTypes[1]) {
                this.$emit('load-event');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.load-more {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: var(--color--light-blue);
    cursor: pointer;
    width: fit-content;
}
.load-more .text {
    margin-bottom: 4px;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    font-weight: 700;
}
</style>